"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.costReports.title': 'Report dei Costi',
    'reports.costReports.description': 'Visualizza i costi di utilizzo dell\'IA e le analisi',
};
